import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Box, Button, Typography, IconButton } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { TourContext } from '../../contexts/TourContext'
import { PATHS } from '../../constants'
import { AxiosWithAuth } from '../../Utilities/authenticationService'
import moment from 'moment'

const getManagerStoreOrAdminPath = async () => {
    const res = await AxiosWithAuth.get('/stores')
    const stores = res.data
    if (stores?.length > 0) {
        return PATHS.managerSettingsStore.replace(':segCode', stores[0].seg_code)
    }
    return PATHS.adminStoreManagements
}

const TOUR_STEPS = [

    {
        path: PATHS.adminUserManagements,
        target: '[data-tour="user-signup"]',
        content: 'ユーザーの新規登録をしてください。',
        subContent: null
    },
    {
        path: null,
        getPath: getManagerStoreOrAdminPath,
        target: '[data-tour="store-type-select"]',
        content: 'ドロップダウンから店舗タイプを変更できます。',
        subContent: null
    },
    {
        path: null,
        getPath: getManagerStoreOrAdminPath,
        target: '[data-tour="store-hours-section"]',
        content: '通常営業時間と特別営業時間を設定できます。',
        subContent: null
    },
    {
        path: null,
        getPath: getManagerStoreOrAdminPath,
        target: '[data-tour="hlg-table"]',
        content: 'HLG表に必要な情報を入力してください。',
        subContent: '店舗を登録しましたら、その店舗のHLG表に必要な情報を入力してください。',
        scrollAncestorsToTop: true
    },
    {
        path: null,
        getPath: () => {
            const employmentId = localStorage.getItem('selected_emp')
            const calendarYearMonth = localStorage.getItem('frederickSelectedYearMonth')
                ? JSON.parse(localStorage.getItem('frederickSelectedYearMonth'))
                : moment().format('YYYY-MM')
            return PATHS.shiftManagement
                .replace(':employmentId', employmentId)
                .replace(':calendarYearMonth', calendarYearMonth)
                .replace(':tabValue', 'submit')
        },
        target: '[data-tour="shift-submit-calendar"]',
        content: 'シフトを提出したい日を選択して、希望の時間を入力してください。',
        subContent: null
    },
    {
        path: null,
        getPath: () => {
            const employmentId = localStorage.getItem('selected_emp')
            const calendarYearMonth = localStorage.getItem('frederickSelectedYearMonth')
                ? JSON.parse(localStorage.getItem('frederickSelectedYearMonth'))
                : moment().format('YYYY-MM')
            return PATHS.shiftManagement
                .replace(':employmentId', employmentId)
                .replace(':calendarYearMonth', calendarYearMonth)
                .replace(':tabValue', 'submit')
        },
        target: '[data-tour="shift-submit-button"]',
        content: 'シフトを提出してください。',
        subContent: null
    },
    {
        path: null,
        getPath: () => {
            const employmentId = localStorage.getItem('selected_emp')
            const calendarYearMonth = localStorage.getItem('frederickSelectedYearMonth')
                ? JSON.parse(localStorage.getItem('frederickSelectedYearMonth'))
                : moment().format('YYYY-MM')
            return PATHS.shiftManagement
                .replace(':employmentId', employmentId)
                .replace(':calendarYearMonth', calendarYearMonth)
                .replace(':tabValue', 'status')
        },
        target: '[data-tour="create-shift-button"]',
        content: 'シフトを作成してください。',
        subContent: null
    },
    {
        path: null,
        getPath: () => {
            const employmentId = localStorage.getItem('selected_emp')
            const calendarYearMonth = localStorage.getItem('frederickSelectedYearMonth')
                ? JSON.parse(localStorage.getItem('frederickSelectedYearMonth'))
                : moment().format('YYYY-MM')
            return PATHS.shiftManagement
                .replace(':employmentId', employmentId)
                .replace(':calendarYearMonth', calendarYearMonth)
                .replace(':tabValue', 'create')
        },
        target: '[data-tour="monthly-shift-tabs"]',
        content: '希望シフトタブでは、従業員が提出したシフトを右クリックで選択して、編集することができます。',
        subContent: null
    },
    {
        path: null,
        getPath: () => {
            const employmentId = localStorage.getItem('selected_emp')
            const calendarYearMonth = localStorage.getItem('frederickSelectedYearMonth')
                ? JSON.parse(localStorage.getItem('frederickSelectedYearMonth'))
                : moment().format('YYYY-MM')
            return PATHS.shiftManagement
                .replace(':employmentId', employmentId)
                .replace(':calendarYearMonth', calendarYearMonth)
                .replace(':tabValue', 'create')
        },
        target: '[data-tour="monthly-shift-day-header"]',
        content: '日付を選択して、その日のシフトを編集することができます。',
        subContent: null
    },
    {
        path: null,
        getPath: () => {
            const employmentId = localStorage.getItem('selected_emp')
            const calendarYearMonth = localStorage.getItem('frederickSelectedYearMonth')
                ? JSON.parse(localStorage.getItem('frederickSelectedYearMonth'))
                : moment().format('YYYY-MM')
            return PATHS.shiftManagement
                .replace(':employmentId', employmentId)
                .replace(':calendarYearMonth', calendarYearMonth)
                .replace(':tabValue', 'create')
        },
        target: '[data-tour="shift-send-dates-row"]',
        content:
            'シフトの編集が終わったら、従業員に公開する日付を選択して、「シフトを送信する」ボタンを押してください。送信した時点でのシフトが従業員に公開されますので、それ以降編集したシフトは再度公開を選択する必要があります。',
        subContent: null
    }
]

const TOOLTIP_MIN_WIDTH = 320
const VIEWPORT_PADDING = 16
const GAP = 12

/** Conservative max height for clamp math so the popover stays inside the viewport (actual card uses maxHeight + scroll). */
const getTooltipEstHeight = () => Math.min(420, Math.max(280, window.innerHeight * 0.72))

const pollForElement = (selector, maxAttempts = 50) => {
    return new Promise((resolve) => {
        let attempts = 0
        const check = () => {
            const el = document.querySelector(selector)
            if (el) {
                resolve(el)
                return
            }
            attempts++
            if (attempts >= maxAttempts) {
                resolve(null)
                return
            }
            requestAnimationFrame(() => setTimeout(check, 100))
        }
        check()
    })
}

const waitForLayoutAfterScroll = () =>
    new Promise((resolve) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => resolve())
        })
    })

/** Used only for steps with scrollAncestorsToTop (HLG card). Resets window and nested overflow scrollers. */
const scrollWindowAndAncestorsToTop = (el) => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    if (document.documentElement) {
        document.documentElement.scrollTop = 0
        document.documentElement.scrollLeft = 0
    }
    if (document.body) {
        document.body.scrollTop = 0
        document.body.scrollLeft = 0
    }
    let node = el
    while (node && node !== document.documentElement) {
        if (node.scrollTop > 0) node.scrollTop = 0
        if (node.scrollLeft > 0) node.scrollLeft = 0
        node = node.parentElement
    }
}

const TourOverlay = () => {
    const { isTourActive, currentStep, nextStep, endTour } = useContext(TourContext)
    const history = useHistory()
    const location = useLocation()
    const [targetRect, setTargetRect] = useState(null)
    const [tooltipPosition, setTooltipPosition] = useState({ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' })
    const [arrowPlacement, setArrowPlacement] = useState(null)
    const [resolvedPath, setResolvedPath] = useState(null)
    const [isAdvancing, setIsAdvancing] = useState(false)

    const step = isTourActive && TOUR_STEPS[currentStep] ? TOUR_STEPS[currentStep] : null

    useEffect(() => {
        if (!isTourActive || !step) return

        const navigateAndShow = async () => {
            let pathToUse = step.path
            if (step.getPath) {
                pathToUse = await step.getPath()
                setResolvedPath(pathToUse)
            } else {
                setResolvedPath(pathToUse)
            }

            const currentPath = location.pathname
            const pathMatch = pathToUse && currentPath === pathToUse

            if (!pathMatch && pathToUse) {
                history.push(pathToUse)
            }
        }

        setResolvedPath(null)
        navigateAndShow()
    }, [isTourActive, currentStep])

    useEffect(() => {
        if (!isTourActive || !step) return

        const updatePosition = async () => {
            const el = await pollForElement(step.target)
            if (el) {
                if (step.scrollAncestorsToTop) {
                    scrollWindowAndAncestorsToTop(el)
                    await waitForLayoutAfterScroll()
                    await new Promise((r) => setTimeout(r, 50))
                }
                el.scrollIntoView({
                    block: step.scrollAncestorsToTop ? 'start' : 'center',
                    inline: 'nearest',
                    behavior: 'auto'
                })
                await waitForLayoutAfterScroll()

                const rect = el.getBoundingClientRect()
                setTargetRect(rect)

                const estH = getTooltipEstHeight()
                const spaceAbove = rect.top
                const spaceBelow = window.innerHeight - rect.bottom
                const centerX = rect.left + rect.width / 2

                // Prefer below if enough space, else above; ensure tooltip fits in viewport
                let showAbove = spaceBelow < estH + GAP
                if (showAbove && spaceAbove < estH + GAP) {
                    showAbove = spaceAbove >= spaceBelow
                }
                if (step.scrollAncestorsToTop && rect.top < 200 && spaceBelow >= estH + GAP) {
                    showAbove = false
                }

                setArrowPlacement(showAbove ? 'bottom' : 'top')

                let top
                if (showAbove) {
                    top = rect.top - GAP
                    const minTop = VIEWPORT_PADDING + estH
                    top = Math.max(top, minTop)
                } else {
                    top = rect.bottom + GAP
                    const maxTop = window.innerHeight - estH - VIEWPORT_PADDING
                    top = Math.min(top, maxTop)
                }

                const halfWidth = TOOLTIP_MIN_WIDTH / 2
                const left = Math.max(halfWidth + VIEWPORT_PADDING, Math.min(window.innerWidth - halfWidth - VIEWPORT_PADDING, centerX))

                setTooltipPosition({
                    top,
                    left,
                    transform: showAbove ? 'translate(-50%, -100%)' : 'translate(-50%, 0)'
                })
            } else {
                setTargetRect(null)
                setArrowPlacement(null)
                setTooltipPosition({ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' })
            }
        }

        const delay = step.path || resolvedPath ? 300 : 100
        const timeout = setTimeout(() => {
            void updatePosition()
        }, delay)
        // Second pass after navigation / long pages so scrollIntoView + layout settle before measuring
        const timeoutRefine = setTimeout(() => {
            void updatePosition()
        }, delay + 400)
        return () => {
            clearTimeout(timeout)
            clearTimeout(timeoutRefine)
        }
    }, [isTourActive, currentStep, step?.target, location.pathname, resolvedPath])

    const handleNext = async () => {
        if (currentStep >= TOUR_STEPS.length - 1) {
            endTour()
            return
        }
        setIsAdvancing(true)
        nextStep()
        setIsAdvancing(false)
    }

    if (!isTourActive) return null

    // Ant Design-style: blue primary, clean typography
    const antdBlue = '#1677ff'
    const antdBlueHover = '#4096ff'

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9999,
                pointerEvents: 'auto'
            }}
        >
            {/* Overlay: spotlight cutout - Ant Design uses rgba(0,0,0,0.45) */}
            {targetRect ? (
                <Box
                    sx={{
                        position: 'fixed',
                        top: targetRect.top - 8,
                        left: targetRect.left - 8,
                        width: targetRect.width + 16,
                        height: targetRect.height + 16,
                        borderRadius: '8px',
                        border: '3px solid #fff',
                        boxShadow: '0 0 0 9999px rgba(0,0,0,0.45), 0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)',
                        pointerEvents: 'none'
                    }}
                />
            ) : (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.45)'
                    }}
                />
            )}
            {/* Popover card - Ant Design style: white bg, 8px radius, subtle shadow */}
            <Box
                sx={{
                    position: 'fixed',
                    ...tooltipPosition,
                    maxWidth: 400,
                    minWidth: 320,
                    zIndex: 10001,
                    pointerEvents: 'auto',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 6px 16px 0 rgba(0,0,0,0.08), 0 3px 6px -4px rgba(0,0,0,0.12), 0 9px 28px 8px rgba(0,0,0,0.05)',
                    overflow: 'visible',
                    '&::before': arrowPlacement && targetRect ? {
                        content: '""',
                        position: 'absolute',
                        left: '50%',
                        marginLeft: '-8px',
                        width: 0,
                        height: 0,
                        borderLeft: '8px solid transparent',
                        borderRight: '8px solid transparent',
                        borderTop: arrowPlacement === 'top' ? '8px solid #fff' : 'none',
                        borderBottom: arrowPlacement === 'bottom' ? '8px solid #fff' : 'none',
                        ...(arrowPlacement === 'top' ? { top: -8 } : { bottom: -8 }),
                        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.08))'
                    } : {}
                }}
            >
                {/* Inner scroll keeps long copy inside the viewport; outer stays overflow:visible for the arrow */}
                <Box
                    sx={{
                        position: 'relative',
                        px: 3,
                        pb: 2,
                        pt: 3,
                        maxHeight: 'min(72vh, calc(100vh - 32px))',
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    }}
                >
                    <IconButton
                        size="small"
                        onClick={endTour}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            color: 'rgba(0,0,0,0.45)',
                            '&:hover': { color: 'rgba(0,0,0,0.88)' }
                        }}
                    >
                        <CloseIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                    <Typography
                        sx={{
                            fontSize: 14,
                            lineHeight: 1.5715,
                            color: 'rgba(0,0,0,0.88)',
                            mb: step.subContent ? 1 : 2
                        }}
                    >
                        {step?.content}
                    </Typography>
                    {step?.subContent && (
                        <Typography
                            sx={{
                                fontSize: 14,
                                lineHeight: 1.5715,
                                color: 'rgba(0,0,0,0.65)',
                                mb: 2,
                                whiteSpace: 'pre-line'
                            }}
                        >
                            {step.subContent}
                        </Typography>
                    )}
                    {/* Step indicator dots - Ant Design style */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                        {TOUR_STEPS.map((_, idx) => (
                            <Box
                                key={idx}
                                sx={{
                                    width: idx === currentStep ? 8 : 6,
                                    height: idx === currentStep ? 8 : 6,
                                    borderRadius: '50%',
                                    backgroundColor: idx <= currentStep ? antdBlue : 'rgba(0,0,0,0.15)',
                                    opacity: idx === currentStep ? 1 : idx < currentStep ? 0.6 : 1,
                                    transition: 'all 0.2s'
                                }}
                            />
                        ))}
                        <Typography component="span" sx={{ fontSize: 12, color: 'rgba(0,0,0,0.45)', ml: 0.5 }}>
                            {currentStep + 1} / {TOUR_STEPS.length}
                        </Typography>
                    </Box>
                    {/* Footer */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Button
                            size="small"
                            onClick={endTour}
                            sx={{
                                color: 'rgba(0,0,0,0.65)',
                                fontSize: 14,
                                textTransform: 'none',
                                '&:hover': { color: 'rgba(0,0,0,0.88)', backgroundColor: 'transparent' }
                            }}
                        >
                            スキップ
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            disableElevation
                            onClick={handleNext}
                            disabled={isAdvancing}
                            sx={{
                                backgroundColor: antdBlue,
                                fontSize: 14,
                                textTransform: 'none',
                                borderRadius: '6px',
                                px: 2,
                                '&:hover': { backgroundColor: antdBlueHover }
                            }}
                        >
                            {currentStep >= TOUR_STEPS.length - 1 ? '完了' : '次へ'}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default TourOverlay
